import React, {Component, Fragment } from 'react';
import {connect} from 'react-redux';
import { getMediaPath }   from 'app/functions';

//actions
import { addPopup } from 'redux/actions';

//popup types
import * as popups from 'constants/popup-types';

//assets
import './app-banner.scss';

class AppBanner extends Component {


    handleAppDownloadClick() {
        if (this.props.deviceState === 'mobile') {
            window.location.href = this.props.app_link;
        } else {
            this.props.addPopup({
                type: popups.IMAGE_POPUP,
                image: { src: getMediaPath(this.props.appPopup.image), alt: this.props.translations['mega_menu_hot_app'] }
            });
        }
    }


    render() {
        const device = this.props.deviceState;
        const data = this.props.data;
        let image = device === 'mobile' ? data.mobileImage : data.image;
        let text_color = device === 'mobile' ? 'blue' : data.text_color;

        return (
            <section className="app-banner" onClick= { this.handleAppDownloadClick.bind(this) } style={{cursor: 'pointer'}}>
                <div className={"content " + text_color} >
                    <div className="title">&nbsp;</div>
                    { device !== 'mobile' &&
                        <Fragment>
                        </Fragment>
                    }
                    { device === 'mobile' &&
                        <a href= { this.props.app_link } title="להורדה" target="_blank" rel="noopener noreferrer">
                        </a>
                    }
                </div>
                <img className="image" src= { getMediaPath(image) } alt="" />
            </section>
        );
    }
}

const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        app_link: store.config.AppStoreLink,
        appPopup: store.config.PopTrans.application,
        translations: store.config.Translations

    }
}
const mapDispatchToProps = dispatch => {
    return {
        addPopup: (payload) => dispatch(addPopup(payload)),
    }
}

//connect to redux store - maps dispatch and redux state to props
export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(AppBanner);
